import { useEffect } from 'react';

export interface UseConditionalCallbackParams<Type> {
	value: Type;
	condition: ((T: Type) => boolean) | (() => boolean);
	callback: (T?: Type) => void;
}

export default <Type>({ value, callback, condition }: UseConditionalCallbackParams<Type>) => {
	useEffect(() => {
		console.log('eval value', value);
		if (condition(value)) {
			callback(value);
		}
	}, [value]);
};
